import { MatSidenav } from '@angular/material/sidenav';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FiltreService } from 'src/app/core/filtre.service';
import { FilterBcDTO } from 'src/app/shared/dtos/filterBcDTO';
import { FilterBpDTO } from 'src/app/shared/dtos/filterBpDTO';
import {default as packageInfo} from 'package.json';
import { GlobalSettingsService } from 'src/app/core/gobal-settings.service';
import { environment } from 'src/environments/environment';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public version = packageInfo.version;
  public versionSmall = packageInfo.version.substr(0, 5);
  filtre: FilterBcDTO;
  filtreBp: FilterBpDTO;
  bpDisplayState: any;
  droitInterface = false;
  environment: boolean = environment.CREATE_BP;
  @Input() isExpanded: boolean;
  @Input() isShowing: boolean;
  @ViewChild('sidenav') sidenav: MatSidenav;
  constructor(public router: Router,
              private filtreService: FiltreService,
              private globalSettingsService: GlobalSettingsService,
              private sessionService: SessionService) {
    this.bpDisplayState = this.globalSettingsService.bpDisplayState;
  }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (user) {
        const droitsGenerate = user.droits.filter(droit =>
          (droit.niveau === 5 || droit.niveau === 10) &&
          (droit.type.toUpperCase() === 'INTERFACE')
      );
        const droitsImport = user.droits.filter(droit =>
          (droit.niveau === 2 || droit.niveau === 3 || droit.niveau === 4 || droit.niveau === 10) &&
          (droit.type.toUpperCase() === 'INTERFACE')
      );

        if ((droitsGenerate && droitsGenerate.length > 0) || (droitsImport && droitsImport.length > 0)){
        this.droitInterface = true;
      }
    }
  }

  list_bc(): void {
    this.filtre = new FilterBcDTO();
    this.filtre.type = '';
    this.filtreService.changeFiltre(this.filtre);
  }

  add_bp(): void {
    this.filtre = new FilterBcDTO();
    this.filtre.type = 's_valide_bp';
    this.filtreService.changeFiltre(this.filtre);
  }

  list_bp(): void {
    this.filtreBp = new FilterBpDTO();
    this.filtreBp.type = '';
    this.filtreService.changeFiltreBP(this.filtreBp);
  }
  refresh():void  {
    this.sessionService.silentRefresh();
  }
}
